import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'middleEllipsis',
  standalone: true
})
export class MiddleEllipsisPipe implements PipeTransform {

transform(value: string, startLength: number = 9, endLength: number = 9, maxLength: number = 20): string {
   if (!value) return '';

    // if text is shorter than or equal to maxLength, show full text
    if (value.length <= maxLength) {
      return value;
    }

    const start = value.slice(0, startLength);
    const end = value.slice(-endLength);

    // return truncated version with ellipsis in the middle
    return `${start}…${end}`;
  }

}
